export default __webpack_public_path__ + "b07ae7be5cde8090e32cc4f0d6d4f6b1.webp";